<template>
    <div class="createField">
        <el-button @click="createFieldClick" class="createBtn"><i class="icon-create"></i>新增字段</el-button>
        <!-- 弹窗 创建模板 -->
        <el-dialog title="字段编辑" :visible.sync="createFieldVisible" :modal="true" :close-on-click-modal="false"
            width="45%" class="fieldDialog" :append-to-body="true" ref="commitDialog">
            <div class="content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="英文代码" prop="dityCode">
                        <el-input v-model="ruleForm.dityCode" placeholder="请填写英文代码(仅支持大小写字母和下划线)"></el-input>
                    </el-form-item>
                    <el-form-item label="字段名称" prop="dityName">
                        <el-input v-model="ruleForm.dityName" placeholder="请填写字段名称"></el-input>
                    </el-form-item>
                    <el-form-item label="大模型调优" prop="dityNameLlm">
                        <el-input v-model="ruleForm.dityNameLlm"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <p style="color: red">*同账户下，英文代码及字段名称必须唯一</p>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="footer">
                <el-button type="primary" class="cancel" @click="createFieldCancelDialog">取&nbsp;&nbsp;消</el-button>
                <el-button type="primary" class="confirm" @click="createFieldConfirmDialog('ruleForm')">
                    确&nbsp;&nbsp;定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    export default {
        name: 'createField',
        props: {
            editObj: Object
        },
        data() {
            var checkName = (rule, value, callback) => {
                var reg = /[^A-Za-z_]/
                if (reg.test(value)) {
                    return callback(new Error('仅支持大小写字母和下划线'));
                } else {
                    callback()
                }
            };
            return {
                showImage: true,
                uploadURL: this.$uploadFile.url,
                createFieldVisible: false,
                ruleForm: {},
                rules: {
                    dityName: [
                        {
                            required: true,
                            message: '请填写字段名称',
                            trigger: ['blur', 'change']
                        }
                    ],
                    dityCode: [
                        {
                            required: true,
                            message: '请填写英文代码',
                            trigger: ['blur', 'change']
                        },
                        { required: true, message: '仅支持大小写字母和下划线', validator: checkName, trigger: 'blur' }
                    ]
                },
                thumbnail: '',
                editId: ''
            }
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters([
                'editType',
                'createField',
                'currentImage',
                'username',
                'localPage'
            ])
        },
        components: {},
        watch: {
            editObj(n) {
                this.editId = n.id
                this.$set(this.ruleForm, 'dityCode', n.dityCode ? n.dityCode : '')
                this.$set(this.ruleForm, 'dityName', n.dityName ? n.dityName : '')
                this.$set(this.ruleForm, 'dityNameLlm', n.dityNameLlm ? n.dityNameLlm : '')
            }
        },
        mounted() { },
        methods: {
            createFieldClick() {
                this.createFieldVisible = true
            },
            createFieldCancelDialog() {
                this.createFieldVisible = false
                this.ruleForm = {}
                this.editId = ''
            },
            createFieldConfirmDialog(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.ruleForm.dityFlag = 0
                        let url = ''
                        if (this.editId) {
                            url = this.$resource.updateDictType.replace('{id}', this.editId)
                        } else {
                            url = this.$resource.addDictType
                        }

                        this.$axios({
                            url: url,
                            method: 'POST',
                            data: this.ruleForm
                        }).then(res => {
                            if (res.data.msg === 'error') {
                                return this.$message.error(res.data.data.msg)
                            }
                            this.$emit('getList')
                            this.$emit('setPage', 1)
                            this.ruleForm = {}
                            this.editId = ''
                            this.createFieldVisible = false
                        })
                    } else {
                        //console.log('error submit!!')
                        return false
                    }
                })
            }
        }
    }
</script>
<style>
    .createField {
        .createBtn {
            background: var(--color-title);
            border: 1px solid var(--color-title);
            border-radius: 5px;
            font-size: 14px;
            color: #fff;
            padding: 4px 10px;
            line-height: 1;
            width: 110px;
            background: #3d7fff;
            font-size: 14px;
            color: #fff;
            height: 32px;
            line-height: 32px;
            padding: 0;
            border-radius: 4px;
            font-weight: normal;
            /*display: flex;
        align-items: center;
        justify-content: center;*/

            .icon-create {
                margin-right: 8px;
            }
        }
    }

    .fieldDialog {
        .el-dialog {
            min-height: 200px;
        }

        .el-dialog__body {
            /* height: 200px; */
            padding: 30px 42px;

            .el-form-item__content {
                /* width: 100%; */
            }

            .content {
                height: 100%;

                .top {
                    display: flex;
                    align-items: end;
                    height: calc(100%);
                    margin: 0;

                    .create-upload {
                        height: 100%;

                        .el-upload {
                            display: block;
                            height: 100%;
                        }

                        .upload-file {
                            width: 100%;
                            height: 100%;
                            margin: 0 auto;
                            background: url(../../assets/images/bgnonefile.png) 50% 30% no-repeat;
                            background-size: 140px 116px;

                            .dragnone {
                                position: relative;
                                top: 54%;
                            }

                            .icon-upload {
                                margin-right: 5px;
                            }

                            .icon-upload:before {
                                color: #fff;
                            }

                            .uploadBtn {
                                background: var(--color-title);
                                color: #fff;
                                width: 100px;
                                height: 36px;
                                line-height: 36px;
                                padding: 0;
                                border-radius: 4px;
                                font-size: 14px;
                                font-weight: normal;
                            }

                            .box {
                                display: block;
                                padding-top: 18px;
                                width: 60%;
                                text-align: left;
                                margin: 0 auto;
                            }

                            .tips {
                                color: #999999;
                                line-height: 22px;
                                font-size: 12px;
                            }
                        }

                        .el-upload-list {
                            display: none;
                        }

                        .el-icon-plus {
                            position: absolute;
                            top: 8px;
                            left: 211px;
                            font-size: 28px;
                            color: #aeaeae;
                            margin-top: 24px;
                            display: none;
                        }

                        .el-upload__text {
                            position: absolute;
                            top: 49px;
                            left: 211px;
                            color: #c4c5c6;
                            margin-top: 18px;
                        }
                    }

                    .reset-upload-demo {
                        position: absolute;
                        top: 7px;
                        left: 16px;
                        z-index: 1;

                        .el-upload-list {
                            display: none;
                        }

                        .reset {
                            font-size: 12px;
                            height: 20px;
                            line-height: 20px;
                            display: flex;
                            align-items: center;

                            .icon-upload {
                                font-size: 12px;
                                margin-right: 5px;
                            }
                        }
                    }

                    .left {
                        width: 50%;
                        height: 100%;
                        background: #fafbfc;
                        border: 1px solid #dfe2e6;
                        position: relative;
                        margin-right: 24px;
                        overflow: hidden;
                        min-height: 200px;
                        border-radius: 4px;
                    }

                    .right {
                        width: 50%;

                        .info {
                            color: #c2c2c2;
                            font-size: 12px;
                        }

                        .selectMul {
                            .el-select {
                                width: 100%;
                            }

                            .el-tag.el-tag--info {
                                background: #f1f8ff;
                                border: 0;
                                /*border-color: #e9e9eb;*/
                                /*color: #909399;*/
                            }

                            .el-select__tags-text {
                                color: #8399c4;
                                max-width: none;
                                text-overflow: inherit;
                            }

                            .el-tag.el-tag--info .el-tag__close {
                                background-color: #8399c4;
                                color: #fff;
                            }
                        }

                        .el-radio__input {
                            display: none;
                        }

                        .el-radio__label {
                            height: 32px;
                            background: #f2f2f2;
                            font-size: 14px;
                            color: #999999;
                            display: inline-block;
                            line-height: 32px;
                            text-align: center;
                            padding: 0 10px;
                        }

                        .is-checked {
                            .el-radio__label {
                                height: 32px;
                                background: #f1f8ff;
                                font-size: 14px;
                                color: #3d7fff;
                                display: inline-block;
                                line-height: 32px;
                                text-align: center;
                                padding: 0 10px;
                                border: 1px solid rgba(61, 127, 255, 0.61);
                            }
                        }
                    }
                }
            }
        }

        .footer {
            position: absolute;
            right: 40px;
            bottom: 30px;
            text-align: right;
            margin-top: 20px;
        }

        .pageImage {
            position: absolute;
            top: 13px;
            right: 26px;
            font-size: 14px;
            color: #2b2b2b;
        }
    }
</style>